import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.integracao_rms_ativa)?_c(VBtn,{staticClass:"mr-5",attrs:{"small":"","color":"primary"},on:{"click":_setup.exportar}},[_c(VIcon,{staticClass:"mr-1",attrs:{"size":18}},[_vm._v("mdi-file-export")]),_vm._v("\n  Exportação RMS\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }